/**
 * Static catalogs for the Flexi "request a quote" forms. Keys are the
 * stable identifiers sent to the backend (which maps them to Norwegian
 * labels for the sales email); the i18n keys drive the on-screen labels.
 *
 * RequestType matches the backend enum: 0 = OptionalServices
 * (Tilleggstjenester), 1 = AvailableModules (Tilleggsmoduler).
 */

export type FlexiRequestType = 0 | 1;

export const FLEXI_REQUEST_OPTIONAL_SERVICES: 0 = 0;
export const FLEXI_REQUEST_AVAILABLE_MODULES: 1 = 1;

export interface FlexiRequestOption {
  /** Stable key sent to the backend. */
  key: string;
  /** i18n key for the checkbox label. */
  labelKey: string;
  /** Optional i18n key for the descriptive sub-line (modules list their sub-features). */
  descKey?: string;
}

/** Tilleggsmoduler — Additional Modules (RequestType = 1). */
export const ADDITIONAL_MODULE_OPTIONS: FlexiRequestOption[] = [
  { key: 'hms', labelKey: 'FLEXI_CUSTOMER_REQUEST.MODULES.HMS', descKey: 'FLEXI_CUSTOMER_REQUEST.MODULES.HMS_DESC' },
  { key: 'personal', labelKey: 'FLEXI_CUSTOMER_REQUEST.MODULES.PERSONAL', descKey: 'FLEXI_CUSTOMER_REQUEST.MODULES.PERSONAL_DESC' },
  { key: 'ik-mat', labelKey: 'FLEXI_CUSTOMER_REQUEST.MODULES.IK_MAT', descKey: 'FLEXI_CUSTOMER_REQUEST.MODULES.IK_MAT_DESC' },
  { key: 'stoffkartotek', labelKey: 'FLEXI_CUSTOMER_REQUEST.MODULES.STOFFKARTOTEK' },
];

/** Tilleggstjenester — Additional Services (RequestType = 0). */
export const ADDITIONAL_SERVICE_OPTIONS: FlexiRequestOption[] = [
  { key: 'collaboration-evaluation-meetings', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.COLLABORATION_MEETINGS' },
  { key: 'safety-inspection', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.SAFETY_INSPECTION' },
  { key: 'mapping-risk-assessment', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.MAPPING_RISK' },
  { key: 'physical-work-environment', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.PHYSICAL' },
  { key: 'amu-participation', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.AMU' },
  { key: 'ergonomics', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.ERGONOMICS' },
  { key: 'chemical-biological', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.CHEMICAL_BIOLOGICAL' },
  { key: 'psychosocial', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.PSYCHOSOCIAL' },
  { key: 'sick-leave-measures', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.SICK_LEAVE' },
  { key: 'targeted-health-check', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.HEALTH_CHECK' },
  { key: 'vaccination', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.VACCINATION' },
  { key: 'courses', labelKey: 'FLEXI_CUSTOMER_REQUEST.SERVICES.COURSES' },
];
